import React, { Component } from 'react';
import { PHOTO_PLACEHOLDER } from '../../constants/images';

import * as apiHelper from '../../apiHelper';
import { renderCard } from '../listings/featured-listings-component';

class RelevantListings extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isFetchingListings: false,
      relevantListings: []
    }

    this.fetchPostTags = this.fetchPostTags.bind(this);
    this.fetchRelevantListings = this.fetchRelevantListings.bind(this);
  }

  fetchPostTags = () => {
    if (typeof __POST_ID__ === 'undefined')
      return;

    const postId = __POST_ID__;

    const query = `?post=${postId}`;
    fetch(`/wp-json/wp/v2/tags${query}`)
      .then(response => response.json())
      .then(json => {
        this.fetchRelevantListings(json.map(tag => tag.id.toString()));
      })
  }

  fetchRelevantListings = (tags) => {

    if (!tags || !tags.length)
      return;

    this.setState({
      ...this.state,
      isFetchingListings: true
    })

    apiHelper.apiPost('listing/tags', { tags: tags })
      .then(response => response.json())
      .then(json => {
        this.setState({
          ...this.state,
          relevantListings: json.slice(0, 2),
          isFetchingListings: false
        })
      })
  }

  componentDidMount = () => {
    this.fetchPostTags();
  }

  render() {
    if (this.state.isFetchingListings || !this.state.relevantListings.length)
      return null;

    return (
      <div className="relevant-listings">
        <div className="featured-head">
          <h2 className="featured-title">Related Properties</h2>
        </div>
        <div className="card-section">
          {this.state.relevantListings.map(listing => renderCard(listing))}
        </div>
      </div>
    )
  }
}

export default RelevantListings;
